var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-overlay',[_c('RecuperarSenha')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }